export const getUsersAPI = "/users";
export function getUserAPI(id) {
  return "/users/" + id;
}
